import { render } from "./BvHeader.vue?vue&type=template&id=41104828&scoped=true"
import script from "./BvHeader.vue?vue&type=script&lang=js"
export * from "./BvHeader.vue?vue&type=script&lang=js"

import "./BvHeader.vue?vue&type=style&index=0&id=41104828&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41104828"]])

export default __exports__